import React from "react";
import Breadcrumb from "../ProfileCommon/Breadcrumb";
import NewHeader from "../../Home/NewHeader";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ProfileChevron from "../ProfileCommon/ProfileChevron";
import { usePostHog } from "../../../hooks/usePostHog";

const Support = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { trackEvent } = usePostHog();

  // Track support page viewed
  React.useEffect(() => {
    trackEvent('support_page_viewed', {
      access_time: new Date().toISOString()
    });
  }, [trackEvent]);

  const handleNavigateToPolicy = () => {
    trackEvent('support_navigation', {
      destination: 'data_protection_policy',
      action: 'view_policy'
    });
    navigate("/profile/support/protection/policy");
  };

  const handleNavigateToFAQ = () => {
    trackEvent('support_navigation', {
      destination: 'faq',
      action: 'view_faq'
    });
    navigate("/profile/support/faq");
  };

  const handleNavigateToContact = () => {
    trackEvent('support_navigation', {
      destination: 'contact_us',
      action: 'contact_support'
    });
    navigate("/profile/support/contactUS");
  };

  return (
    <div className="flex overflow-hidden flex-col mx-auto w-full bg-white max-w-[480px]">
      <div className="flex flex-col w-full min-h-[912px]">
        <div className="fixed top-0 left-0 w-full z-50">
          <NewHeader />
        </div>
        <div className="h-7"></div>
        <div className="flex flex-col flex-1 gap-3 py-3.5 px-[30px] mt-4">
          <Breadcrumb
            breadCrumbTiltle={t("profile.support")}
            onClickBack={() => navigate("/profile")}
          />

          <ProfileChevron
            title={t("support.dataProtectionPolicy")}
            onClick={handleNavigateToPolicy}
          />
          <ProfileChevron
            title={t("support.faq")}
            onClick={handleNavigateToFAQ}
          />
          <ProfileChevron
            title={t("support.contactUs")}
            onClick={handleNavigateToContact}
          />
        </div>
      </div>
    </div>
  );
};

export default Support;
